import React from 'react';
import { ListItem, ListItemText, makeStyles, Theme, createStyles } from '@material-ui/core';
import { TagDefinition, TagType } from '../../../../models';
import { Checkbox } from 'src/components/ui/form/Checkbox';
import { splitCamelCaseExcluding } from 'src/helpers/strings';

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    nestedListItem: {
      marginLeft: 0,
      padding: '0 8px',
    },
  })
);

export interface TagListItemProps {
  tag: TagDefinition;
  onToggle?: (tagId: string) => void;
  isSelected?: boolean;
  disabled?: boolean;
  showCheckbox?: boolean;
}

const labelsToOmmit = ['SoC', 'SoC_SF', 'SoH'];

export const TagListItem: React.FC<TagListItemProps> = ({
  tag,
  onToggle,
  isSelected = false,
  disabled = false,
  showCheckbox = false,
}) => {
  const classes = useStyles();

  const handleCheckboxToggle = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onToggle?.(tag.id);
  };

  const label = splitCamelCaseExcluding(tag.label, labelsToOmmit);
  return (
    <ListItem
      key={tag.id}
      dense
      button
      className={classes.nestedListItem}
      disabled={disabled || !showCheckbox}
      onClick={showCheckbox ? handleCheckboxToggle : undefined}
    >
      {showCheckbox && (
        <Checkbox edge="start" checked={isSelected} disabled={disabled} size="small" />
      )}
      <ListItemText>
        {tag.label === tag.id ? <em>{label}</em> : <>{label}</>}
        {tag.tagType !== TagType.Alarm && (
          <span data-testid={`units-container-${tag.id}`}>&nbsp;({tag.unit})</span>
        )}
      </ListItemText>
    </ListItem>
  );
};
